module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', {
    class: {
      lose: _vm.res.valid
    }
  }, [(_vm.isFavorite) ? _c('div', {
    staticClass: "l vux-1px-t danger"
  }, [_c('div', {
    on: {
      "click": _vm.deleteFavorite
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shoucang"
  }), _vm._v(" "), _c('span', [_vm._v("已收藏")])])]) : _c('div', {
    staticClass: "l vux-1px-t"
  }, [_c('div', {
    on: {
      "click": _vm.addFavorite
    }
  }, [_c('i', {
    staticClass: "iconfont icon-shoucang"
  }), _vm._v(" "), _c('span', [_vm._v("收藏")])])]), _vm._v(" "), _c('div', {
    staticClass: "l vux-1px-t"
  }, [_c('div', {
    on: {
      "click": _vm.toShoppCart
    }
  }, [_c('i', {
    staticClass: "iconfont icon-gouwuche"
  }, [(_vm.shopNum) ? _c('b') : _vm._e()]), _vm._v(" "), _c('span', [_vm._v("购物车")])])]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.addProductToCart(_vm.res)
      }
    }
  }, [_vm._v("加入购物车")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.goCreateOrder
    }
  }, [_vm._v("立即购买")])]), _vm._v(" "), _c('toast', {
    attrs: {
      "text": _vm.toastText
    },
    model: {
      value: (_vm.show1),
      callback: function($$v) {
        _vm.show1 = $$v
      },
      expression: "show1"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e1190828"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Detail/Footer.vue
// module id = 621
// module chunks = 0